/**
 * @description lists the column headers that could not be mapped to seccon fields
 */

import React from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import NoResults from '@seccon/shared/ui/components/NoResults';

import { SyncResultsContext } from '../contexts/SyncResults';

const styles = {
  heading: {
    width: '100%'
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    justifyContent: 'center',
    width: '100%'
  },
  listEntry: {
    p: 2
  },
  subheading: {
    color: 'text.secondary'
  }
};

const UnmappedColumns = () => {
  const results = React.useContext(SyncResultsContext);
  const { unmappedHeaders: list = [] } = results ?? {};

  return (
    <>
      <Box>
        <Typography sx={styles.heading} variant='h6'>Unmapped Columns</Typography>
        <Typography sx={styles.subheading} variant='subtitle2'>Columns from your personnel spreadsheet that do not have a defined mapping to a field in Security Control</Typography>
      </Box>
      {list.length > 0 ? (
        <Box sx={styles.listContainer}>
          {list.map((entry) => (
            <Paper key={entry} sx={styles.listEntry}>
              {entry}
            </Paper>
          ))}
        </Box>
      ) : (
        <NoResults Icon={CheckCircleOutlineOutlinedIcon}>No Unmapped Columns</NoResults>
      )}
    </>
  );
};

export default UnmappedColumns;
